import { useEffect, useState } from 'react'
import { GanttParameterVO } from '../../../../domain/value-object/GanttParameterVO'
import { CalendarDateVO } from '../../../../domain/value-object/CalendarDateVO'
import { generateGanttScale } from '../../../containers/commons/AgGrid/components/cell/custom/gantt/ganttUtil'

export const useGanttChart = (
  ganttParameter: GanttParameterVO,
  ganttVisible: boolean
) => {
  const [timeScale, setTimeScale] = useState<CalendarDateVO[]>([])
  const [displayTimeScale, setDisplayTimeScale] = useState<CalendarDateVO[]>([])

  useEffect(() => {
    if (!ganttVisible) return
    let cancelled = false
    const generate = async () => {
      const [display, full] = await generateGanttScale(ganttParameter)
      if (!cancelled) {
        setDisplayTimeScale(display)
        setTimeScale(full)
      }
    }
    generate()
    return () => {
      cancelled = true
    }
  }, [ganttParameter, ganttVisible])

  return { timeScale, displayTimeScale }
}
